import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const MyProfile = () => {
  const navigate = useNavigate();
  const [spinner, setSpinner] = useState(true);
  const [changePasswordModal, setChangePasswordModal] = useState(false);
  const [logoutModal, setLogoutModal] = useState(false);
  
  // User profile data
  const [profileData, setProfileData] = useState({
    client_id: '',
    name: '',profile_img:'',
    mobile: '',
    email: '',
    city: '',
    pincode: '',
    bank_name: '',
    account_holder: '',
    account_no: '',
    ifsc_code: ''
  });
  
  // Change password form
  const [passwordForm, setPasswordForm] = useState({
    password: '',
    cpassword: ''
  });

  // Check if user is logged in
  useEffect(() => {
    const isLoggedIn = localStorage.getItem('LoggedIn');
    if (!isLoggedIn || isLoggedIn !== '1') {
      toast.error('Please login first');
      navigate('/login');
      return;
    }
    
    loadProfileData();
  }, [navigate]);

  const loadProfileData = async () => {
    try {
      setSpinner(true);
      const userid = localStorage.getItem('userid');
      const username = localStorage.getItem('name');
      const useremail = localStorage.getItem('email');
      
      if (!userid) {
        toast.error('User ID not found');
        navigate('/login');
        return;
      }

      // Set basic user data from localStorage
      setProfileData(prev => ({
        ...prev,
        client_id: userid,
        name: username || '',
        email: useremail || ''
      }));

      // Fetch detailed user data
      const url = `https://fx4money.com/Rest/user_details_api/${userid}`;
      const response = await fetch(url);
      const data = await response.json();
      setProfileData(prev => ({
        ...prev,
        mobile: data.mobile || '',
        name: data.first_name || prev.name,
        email: data.email || prev.email,
        city: data.city || '',profile_img:data.profile_img,
        pincode: data.zipcode || '',
        bank_name: data.bank_name || '',
        account_holder: data.acc_holder || '',
        account_no: data.acc_no || '',
        ifsc_code: data.ifsc || ''
      }));
      
      setSpinner(false);
    } catch (error) {
      console.error('Error loading profile data:', error);
      toast.error('Failed to load profile data');
      setSpinner(false);
    }
  };

  const handleChangePassword = async (e) => {
    e?.preventDefault();
    
    if (!passwordForm.password || !passwordForm.cpassword) {
      toast.error('Please enter both password fields');
      return;
    }

    if (passwordForm.password !== passwordForm.cpassword) {
      toast.error('Passwords do not match');
      return;
    }

    if (passwordForm.password.length < 5) {
      toast.error('Password must be at least 5 characters long');
      return;
    }

    setSpinner(true);
    
    try {
      const userid = localStorage.getItem('userid');
      
      const formData = new FormData();
      formData.append('password', passwordForm.password);
      formData.append('cpassword', passwordForm.cpassword);

      const response = await fetch(`https://fx4money.com/Rest/web_change_password_api/${userid}`, {
        method: 'POST',
        body: formData
      });

      const responseData = await response.json();
      
      if (responseData.status === 0) {
        toast.success(responseData.msg || 'Password changed successfully');
        setChangePasswordModal(false);
        setPasswordForm({ password: '', cpassword: '' });
      } else {
        toast.error(responseData.msg || 'Failed to change password');
      }
    } catch (error) {
      console.error('Change password error:', error);
      toast.error('Network error. Please try again.');
    } finally {
      setSpinner(false);
    }
  };

  const handleLogout = () => {
    // Clear all local storage
    localStorage.clear();
    
    // Show success message
    toast.success('Logged out successfully');
    
    // Redirect to login after a short delay
    setTimeout(() => {
      navigate('/login');
    }, 1000);
  };

  const formatClientId = (id) => {
    if (!id) return '#00000';
    return `#${id.toString().padStart(5, '0')}`;
  };

  const ProfileInfoItem = ({ label, value, valueColor = 'text-dark' }) => (
    <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
      <span className="fw-medium">{label}</span>
      <span className={valueColor}>{value || 'Not provided'}</span>
    </div>
  );

  if (spinner && !profileData.name) {
    return (
      <div className="container-fluid bg-light min-vh-100 d-flex justify-content-center align-items-center">
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2">Loading profile...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid bg-light min-vh-100">
      <ToastContainer position="top-right" autoClose={3000} />
      
      {/* Change Password Modal */}
      {changePasswordModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title">Change Password</h5>
                <button 
                  type="button" 
                  className="btn-close btn-close-white"
                  onClick={() => {
                    setChangePasswordModal(false);
                    setPasswordForm({ password: '', cpassword: '' });
                  }}
                ></button>
              </div>
              <form onSubmit={handleChangePassword}>
                <div className="modal-body">
                  <div className="mb-3">
                    <label htmlFor="newPassword" className="form-label text-dark">
                      New Password <span className="text-danger">*</span>
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      id="newPassword"
                      placeholder="Enter new password"
                      value={passwordForm.password}
                      onChange={(e) => setPasswordForm(prev => ({ ...prev, password: e.target.value }))}
                      minLength="5"
                      required
                    />
                    <div className="form-text">Minimum 5 characters</div>
                  </div>
                  
                  <div className="mb-3">
                    <label htmlFor="confirmPassword" className="form-label text-dark">
                      Confirm Password <span className="text-danger">*</span>
                    </label>
                    <input
                      type="password"
                      className="form-control"
                      id="confirmPassword"
                      placeholder="Confirm new password"
                      value={passwordForm.cpassword}
                      onChange={(e) => setPasswordForm(prev => ({ ...prev, cpassword: e.target.value }))}
                      minLength="5"
                      required
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button 
                    type="button" 
                    className="btn btn-secondary"
                    onClick={() => {
                      setChangePasswordModal(false);
                      setPasswordForm({ password: '', cpassword: '' });
                    }}
                  >
                    Cancel
                  </button>
                  <button 
                    type="submit" 
                    className="btn btn-primary"
                    disabled={spinner}
                  >
                    {spinner ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                        Changing...
                      </>
                    ) : (
                      'Change Password'
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Logout Confirmation Modal */}
      {logoutModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-danger">
                  <i className="bi bi-exclamation-triangle me-2"></i>
                  Confirm Logout
                </h5>
                <button 
                  type="button" 
                  className="btn-close"
                  onClick={() => setLogoutModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p class="text-dark">Are you sure you want to logout?</p>
                <p className="text-dark small">You will need to login again to access your account.</p>
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-secondary"
                  onClick={() => setLogoutModal(false)}
                >
                  Cancel
                </button>
                <button 
                  type="button" 
                  className="btn btn-danger"
                  onClick={handleLogout}
                >
                  <i className="bi bi-box-arrow-right me-1"></i>
                  Yes, Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      

      <div className="container py-4">
        {/* Profile Card */}
        <div className="card shadow-lg border-0 mb-4">
          <div className="card-body">
            <div className="row align-items-center mb-4">
              <div className="col-auto">
                
                <img src={profileData.profile_img} width="100px"/>
              </div>
              <div className="col">
                <h4 className="card-title fw-bold mb-1">{profileData.name || 'User'}</h4>
                <p className="card-text text-dark mb-2">
                  {formatClientId(profileData.client_id)}
                </p>
                <span className="badge bg-success">
                  <i className="bi bi-shield-check me-1"></i>
                  Account Active
                </span>
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-md-6">
                <ProfileInfoItem 
                  label="Email Address" 
                  value={profileData.email}
                  valueColor="text-primary"
                />
                <ProfileInfoItem 
                  label="Mobile Number" 
                  value={profileData.mobile}
                />
                <ProfileInfoItem 
                  label="City" 
                  value={profileData.city}
                />
                <ProfileInfoItem 
                  label="Pincode" 
                  value={profileData.pincode}
                />
              </div>
              
              <div className="col-md-6">
                <ProfileInfoItem 
                  label="Bank Name" 
                  value={profileData.bank_name}
                />
                <ProfileInfoItem 
                  label="Account Holder" 
                  value={profileData.account_holder}
                />
                <ProfileInfoItem 
                  label="Account Number" 
                  value={profileData.account_no}
                />
                <ProfileInfoItem 
                  label="IFSC Code" 
                  value={profileData.ifsc_code}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-3 mb-3 mb-md-0">
                <button 
                  className="btn btn-primary w-100"
                  onClick={() => setChangePasswordModal(true)}
                >
                  <i className="bi bi-key me-2"></i>
                  Change Password
                </button>
              </div>
               <div className="col-md-3 mb-3 mb-md-0">
                <button 
                  className="btn btn-primary w-100"
                  onClick={() => navigate('/profile')}
                >
                  <i className="bi bi-key me-2"></i>
                  Kyc Details
                </button>
              </div>

              <div className="col-md-3 mb-3 mb-md-0">
                <button 
                  className="btn btn-primary w-100"
                  onClick={() => navigate('/bank')}
                >
                  <i className="bi bi-key me-2"></i>
                  Bank Details
                </button>
              </div>
              <div className="col-md-3">
                <button 
                  className="btn btn-outline-danger w-100"
                  onClick={() => setLogoutModal(true)}
                >
                  <i className="bi bi-box-arrow-right me-2"></i>
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>

      
        {/* Information & Support */}
        <div className="row">
          <div className="col-md-6 mb-4">
            <div className="card shadow-sm border-0 h-100">
              <div className="card-header bg-white border-0">
                <h6 className="card-title mb-0 fw-bold">
                  <i className="bi bi-info-circle me-2"></i>
                  Information
                </h6>
              </div>
              <div className="card-body">
                <div className="list-group list-group-flush">
                  <button 
                    className="list-group-item list-group-item-action border-0 d-flex justify-content-between align-items-center"
                    onClick={() => navigate('/company')}
                  >
                    <div>
                      <i className="bi bi-building me-2"></i>
                      About Company
                    </div>
                    <i className="bi bi-chevron-right text-dark"></i>
                  </button>
                  
                  <button 
                    className="list-group-item list-group-item-action border-0 d-flex justify-content-between align-items-center"
                    onClick={() => navigate('/contact')}
                  >
                    <div>
                      <i className="bi bi-telephone me-2"></i>
                      Contact Us
                    </div>
                    <i className="bi bi-chevron-right text-dark"></i>
                  </button>
                  
                  <button 
                    className="list-group-item list-group-item-action border-0 d-flex justify-content-between align-items-center"
                   
                  >
                    <div>
                      <i className="bi bi-question-circle me-2"></i>
                      FAQ & Help
                    </div>
                    <i className="bi bi-chevron-right text-dark"></i>
                  </button>
                  
                  <button 
                    className="list-group-item list-group-item-action border-0 d-flex justify-content-between align-items-center"
                     onClick={() => navigate('/terms')}
                  >
                    <div>
                      <i className="bi bi-file-text me-2"></i>
                      Terms & Conditions
                    </div>
                    <i className="bi bi-chevron-right text-dark"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          
          <div className="col-md-6 mb-4">
            <div className="card shadow-sm border-0 h-100">
              <div className="card-header bg-white border-0">
                <h6 className="card-title mb-0 fw-bold">
                  <i className="bi bi-shield-check me-2"></i>
                  Security Center
                </h6>
              </div>
              <div className="card-body">
                <div className="list-group list-group-flush">
                  <div className="list-group-item border-0">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span>Password Strength</span>
                      <span className="badge bg-success">Strong</span>
                    </div>
                    <div className="progress" style={{ height: '5px' }}>
                      <div className="progress-bar bg-success" style={{ width: '100%' }}></div>
                    </div>
                  </div>
                  
                  <div className="list-group-item border-0">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span>Last Login</span>
                      <small className="text-dark">Just now</small>
                    </div>
                  </div>
                  
                  <div className="list-group-item border-0">
                    <div className="d-flex justify-content-between align-items-center">
                      <span>Account Created</span>
                      <small className="text-dark">
                        {new Date().toLocaleDateString('en-IN', {
                          day: 'numeric',
                          month: 'short',
                          year: 'numeric'
                        })}
                      </small>
                    </div>
                  </div>
                  
                  
                </div>
              </div>
            </div>
          </div>
        </div>

       
      </div>

      {/* Footer */}
      <footer className="bg-dark text-white py-3 mt-4">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <small className="opacity-75">© {new Date().getFullYear()} My Profile</small>
            </div>
            <div className="col-md-6 text-md-end">
              <small className="opacity-75">
                <i className="bi bi-person-circle me-1"></i>
                {profileData.name || 'User'} | 
                <span className="ms-2">
                  <i className="bi bi-shield-check me-1"></i>
                  Verified Account
                </span>
              </small>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MyProfile;